import i18n from '@/i18n/index';

export default {
  required: {
    required: true,
    message: i18n.t('form.validations.required'),
    trigger: 'blur',
  },
  email: {
    type: 'email',
    message: i18n.t('form.validations.email'),
    trigger: 'blur',
  },
};



// WEBPACK FOOTER //
// ./src/utils/validations.js